import { coerceBooleanProperty } from '@angular/cdk/coercion'
import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  HostBinding,
  inject,
  Input,
  Output,
  TemplateRef,
} from '@angular/core'
import { CanSize, CanSizeCtor, mixinSize, Size } from './size.mixin'

/**
 * Get a color mixin that CardComponent can extend to handle color inputs
 */
class CardBase {
  _elementRef = inject<ElementRef>(ElementRef)
  constructor() {}
}
const _SizeMixinBase: CanSizeCtor & typeof CardBase = mixinSize(CardBase)

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-card button[appCard], a[appCard]',
  styleUrls: ['./card/card.component.scss'],
  templateUrl: './card/card.component.html',
})
export class CardComponent extends _SizeMixinBase implements CanSize {
  @Input() description?: string
  @Input() index: number
  @Input() imageSrc?: string
  @Input() imageAlt = ''
  @Input() canCheck: boolean
  @Input() checkboxTooltip = ''
  // The libRE input property sets a css class to changes the background color from the default
  @Input() @HostBinding('class.libRE') libRE: boolean
  // The libRETemplate property causes the template replace the thumbnail image with a plus icon and
  // replace the ... menu with a building icon.
  @Input() libRETemplate: boolean

  @HostBinding('class.no-image') get hasImage() {
    return this.imageSrc != null
  }

  // Layout mode
  @Input() set details(value: any) {
    this._details = coerceBooleanProperty(value)
  }
  get details() {
    return this._details
  }
  @HostBinding('class.details') _details = false

  // Checked
  @Input() set checked(value: any) {
    this._checked = coerceBooleanProperty(value)
  }
  get checked() {
    return this._checked
  }
  @HostBinding('class.checked') _checked = false

  // Multiple selection
  @Input() set selectMultiple(value: any) {
    this._selectMultiple = coerceBooleanProperty(value)
  }
  get selectMultiple() {
    return this._selectMultiple
  }
  _selectMultiple = false

  // Focus
  @Input() set indicateFocus(value: any) {
    this._indicateFocus = coerceBooleanProperty(value)
  }
  get indicateFocus() {
    return this._indicateFocus
  }
  @HostBinding('class.indicate-focus') _indicateFocus = false

  // Size mixin
  @Input() size: Size
  @Input() gigantic: boolean
  @Input() huge: boolean
  @Input() big: boolean
  @Input() small: boolean
  @HostBinding('class.gigantic')
  get isSizeGigantic() {
    return this.size === 'gigantic'
  }
  @HostBinding('class.huge')
  get isSizeHuge() {
    return this.size === 'huge'
  }
  @HostBinding('class.big')
  get isSizeBig() {
    return this.size === 'big'
  }
  @HostBinding('class.small')
  get isSizeSmall() {
    return this.size === 'small'
  }

  @Output() handleCheck = new EventEmitter()

  @ContentChild('titleActionTemplate') titleActionTemplate: TemplateRef<any>

  constructor() {
    super()
  }

  onCheckboxClick(event: Event): void {
    if (this.canCheck) {
      event.preventDefault()
      event.stopPropagation()
      this.handleCheck.emit()
    }
  }
}
